import React from 'react';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import styled from 'styled-components/macro';
import InputBase from '../../../components/form/InputBase';
import useTranslations from '../../../hooks/useTranslations';
import { SimpleFlexContainer } from '../../../components/layouts/ng-layouts/Containers';
import Animation from '../../../components/Animation';
import { InputAdornment } from '@material-ui/core';
import { Search } from '@material-ui/icons';

const List = styled.div`
  margin: 8px 0;
`;

const ScoringContainer = styled(SimpleFlexContainer)`
  margin: 0.8rem 0;
  gap: 0.8rem;
  padding-left: 0.8rem;
`;

const ScoringContainerTitle = styled.div`
  font-size: 16px;
  margin: 8px 0;
`;

const SubfieldTitleWrapper = styled.div`
  cursor: pointer;
  font-family: Montserrat;
  font-size: 18px;
  font-weight: 700;
  line-height: 21.94px;
`;

const TextWrapper = styled.div`
  flex: 1;
`;

const InputWrapper = styled.span`
  flex: 1;
`;

const SingleSubFieldWrapper = styled.div`
  height: 250px;
  max-height: 250px;
  overflow-y: auto;
`;

const AnimatedArrow = styled(ExpandMoreIcon)`
  transform: ${props => (props.selected ? 'rotate(0deg)' : 'rotate(270deg)')};
  transition: transform 0.3s;
  vertical-align: bottom;
`;

const SearchWrapper = styled.div`
  position: relative;
`;

const SearchIcon = styled(Search)`
  && {
    margin-right: 0;
    opacity: 0.4;
    position: absolute;
    right: 0.25rem;
    top: 0.25rem;
  }
`;

const ScoringPanelMultiView = props => {
  const t = useTranslations();
  return (
    <SimpleFlexContainer>
      <ScoringContainerTitle>
        Assign a score to a country by entering a number below.
      </ScoringContainerTitle>
      {props.scoringSubfieldInternalIds.map(subfieldId => {
        const subField = props.scoringSubfieldsById[subfieldId];
        if (!subField) {
          return;
        }
        return (
          <List key={subfieldId}>
            <SubfieldTitleWrapper
              onClick={() => props.onExpandSubField(subfieldId)}
            >
              <AnimatedArrow
                selected={props.subFieldData.subfieldExpandedId === subfieldId}
              />
              {subField.title}
            </SubfieldTitleWrapper>
            {props.subFieldData.subfieldExpandedId === subfieldId && (
              <Animation
                type="collapse"
                in={props.subFieldData.subfieldExpandedId === subfieldId}
              >
                <SearchWrapper>
                  <InputBase
                    value={props.subFieldData.filterText}
                    onChange={props.onFilterTextChanged}
                    inputProps={{ 'data-lpignore': true }}
                    placeholder="Search for a country..."
                  />
                  <SearchIcon />
                </SearchWrapper>

                <SingleSubFieldWrapper>
                  {subField.options.map((oneOption, optionIndex) => {
                    // if oneOption not in props.subFieldData.filteredSubfieldOptions, return null;
                    if (
                      !props.subFieldData.filteredSubfieldOptions.includes(
                        oneOption
                      )
                    ) {
                      return null;
                    }
                    return (
                      <ScoringContainer $row key={oneOption}>
                        <TextWrapper>{oneOption}</TextWrapper>
                        <InputWrapper>
                          <InputBase
                            value={
                              props.subFieldData[subfieldId][optionIndex] &&
                              props.subFieldData[subfieldId][optionIndex]
                                .value === 0
                                ? 0
                                : (props.subFieldData[subfieldId][
                                    optionIndex
                                  ] &&
                                    props.subFieldData[subfieldId][optionIndex]
                                      .value) ||
                                  ''
                            }
                            onChange={event => {
                              props.onSubFieldScoringValuesSaved(
                                event,
                                subfieldId,
                                oneOption
                              );
                            }}
                            onBlur={() => {
                              props.onSubFieldScoringValuesBlur(subfieldId);
                            }}
                            inputProps={{ 'data-lpignore': true }}
                          />
                        </InputWrapper>
                      </ScoringContainer>
                    );
                  })}
                </SingleSubFieldWrapper>
              </Animation>
            )}
          </List>
        );
      })}
    </SimpleFlexContainer>
  );
};

export default ScoringPanelMultiView;
